import React, { useRef, useState } from "react";
import IndiaMap from "../../assets/images/map.svg";
import Indiamap from "./Indiamap";
import { InternalGSTData as gstData } from "../../data";

const GSTDetails = () => {
  const [dialogContent, setDialogContent] = useState(gstData[0]);
  const [stateCode, setStateCode] = useState("30");
  const ref = useRef();
  const timeout = useRef();

  const handleHotspotClick = (data) => {
    clearTimeout(timeout.current);
    setStateCode(data.stateCode);
    ref.current.classList.add("op-anim");

    timeout.current = setTimeout(() => {
      ref.current.classList.remove("op-anim");
      setDialogContent(data);
    }, 500);
  };

  return (
    <section className="gst-details-section bg">
      <div className="container">
        <div className="gst-header-box text-center mx-auto mb-5">
          <h2 className="h3-heading mb-3" style={{ lineHeight: '1.2' }}>GST DETAILS</h2>
          <p className="gst-subtitle">
            📍 Pan-India Presence — Click on any state to view our GST registration details
          </p>
        </div>

        <div className="d-lg-flex d-none justify-content-center gap-5">
          <div className="map-hotspots position-relative">
            <Indiamap stateCode={stateCode} />
            {/* <img src={IndiaMap} className="w-100" /> */}
            {gstData.map((data) => {
              return (
                <button
                  key={data.GSTIN}
                  className={`position-absolute state ${data.state} ${
                    dialogContent.state == data.state ? "selected" : ""
                  }`}
                  data-state={data.state}
                  onClick={() => handleHotspotClick(data)}
                  title={data.state}
                ></button>
              );
            })}
          </div>

          <div className="state-data-container" ref={ref}>
            {dialogContent != null && dialogContent && (
              <>
                <div className="state-badge">
                  <span className="location-icon">📍</span>
                  <h3 className="state-name">{dialogContent.state}</h3>
                </div>
                <div className="gst-info-item">
                  <span className="info-label">GSTIN:</span>
                  <span className="info-value">{dialogContent.GSTIN}</span>
                </div>
                <div className="gst-info-item">
                  <span className="info-label">Address:</span>
                  <span className="info-value text-uppercase">
                    {dialogContent.address}
                  </span>
                </div>
                <div className="gst-info-item">
                  <span className="info-label">State Code:</span>
                  <span className="info-value">{dialogContent.stateCode}</span>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="d-lg-none d-flex flex-column">
        <Indiamap stateCode={stateCode} />

          <div className="accordion mb-5" id="gstStatesAccordion">
            {gstData.map((data) => {
              return (
                <div
                  className="accordion-item mb-2"
                  key={`mobile-gst-data-${data.GSTIN}`}
                >
                  <h3
                    className="accordion-header"
                    id={`state-heading-${data.GSTIN}`}
                  >
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#state-${data.GSTIN}`}
                      aria-expanded="false"
                      aria-controls="collapseOne"
                      onClick={()=>setStateCode(data.stateCode)}
                    >
                      {data.state}
                    </button>
                  </h3>
                  <div
                    id={`state-${data.GSTIN}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`state-heading-${data.GSTIN}`}
                    data-bs-parent="#gstStatesAccordion"
                  >
                    <div className="accordion-body">
                      <p>
                        <span className="font-bold">GSTIN:</span> {data.GSTIN}
                      </p>
                      <p>
                        <span className="font-bold">Address:</span>{" "}
                        <span className="text-uppercase">{data.address}</span>
                      </p>
                      <p>
                        <span className="font-bold">State Code:</span>{" "}
                        {data.stateCode}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <p className="text-center fs-4">
          Currently registered for GST in 16 states & UT(s) and expanding
          rapidly to serve you better!
        </p>
      </div>
    </section>
  );
};

export default GSTDetails;
